export default "__VITE_ASSET__Bw$3nSGk__"